import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import Userprofile from "./component";

import { useApiRequest } from "../Login/Hooks/useApiRequest";
import ProfileScreen from "./1";
function clearAllCookies() {
    var cookies = document.cookie.split(";");
  
    //console.log(" clearAllCookies",cookies)
  
    for (var i = 0; i < cookies.length; i++) {
        var cookie = cookies[i];
        var eqPos = cookie.indexOf("=");
        var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
        document.cookie = name + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";


    }
    //console.log("all cookie",document.cookie)
  } 

const UserprofileContainer = () => {
  const navigate = useNavigate();
  const { makeApiRequest } = useApiRequest();

  // -------------------- State --------------------
  const [loader, setLoader] = useState(false);

  const [google_Pop_flag, setGoogle_Pop_flag] = useState(false);
  const [google_OTP_Pop_flag, setGoogle_OTP_Pop_flag] = useState(false);
  const [google_success_flag, setGoogle_success_flag] = useState(false);
    const [paymentOptionsList,setPaymentOptionsList]=useState([])


  const [number, setNumber] = useState("");
  const [otp, setOtp] = useState("");
  const [google_requestId, setGoogle_requestId] = useState(null);
  const [numberError, setNumberError] = useState(false);
  const [otpError, setOtpError] = useState(false);
  const [numberErrorMsg, setNumberErrorMsg] = useState("");
  const [otpErrorMsg, setOtpErrorMsg] = useState("");
    const [profileData, setProfileData] = useState({
    name: "",
    gender: "",
    email: "",
    phone: "",
  });

  const token = localStorage.getItem("UserJWTAuth");
  const deviceId = localStorage.getItem("uuid");

  // -------------------- Effects --------------------
  useEffect(() => {
    
    if (!token){} //navigate("/");
        if(localStorage.getItem('Guest_clientId')){
         
    navigate('/login?route=profile')
  }
    fetchUserDetails();
  }, []);

  // -------------------- API Calls --------------------
  const fetchUserDetails = () => {
    if (!token) return;

    makeApiRequest({
      url: `https://api-prod.daalchini.co.in/auth/user/profile/details`,
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "x-app-platform": "web",
        "x-app-version": "v1.0.1",
        "x-device-id": deviceId || "",
      },
      data: {
        request: { oauthToken: `Bearer ${token}` },
      },
      handleSuccess: handleResponseUserDetails,
      handleError: handleErrorUserDetails,
    });
  };

  const handleResponseUserDetails = (res) => {
//console.log("handleResponseUserDetails",res.data.response)


    const data = res?.data?.response;
    if (data) {
      localStorage.setItem("referCode", data.referCode);
      setProfileData(data);
    }
    setLoader(false);
  };

  const handleErrorUserDetails = (error) => {
    setLoader(false);
    const status = error?.response?.status;

    if (status === 401 || status === 403) {
      const google_jwt = localStorage.getItem("google_jwt");
      if(google_jwt) { 
        setGoogle_Pop_flag(true)

      } 
    } else {
      toast.error(
        error?.response?.data?.status || "Something went wrong",
        { position: "top-right", autoClose: 1000 }
      );
    }
  };

  // -------------------- Logout --------------------
  const handleLogoutResponse = () => {
    clearAllCookies();
    localStorage.removeItem("UserJWTAuth");
    localStorage.clear();

    setLoader(false);
    navigate("/login");
    window.location.reload();
  };

  const handleLogoutError = (error) => {
    setLoader(false);
    const status = error?.response?.status;
    if (status === 401 || status === 403) {
      localStorage.removeItem("UserJWTAuth");
      navigate("/login");
    } else {
      toast.error(error?.response?.data?.status || "Logout failed", {
        position: "top-right",
        autoClose: 1000,
      });
    }
  };

  const LogoutCurrentDevice = () => {
    makeApiRequest({
      url: `https://api-prod.daalchini.co.in/auth/user/logout`,
      method: "DELETE",
      headers: {
        Authorization: `Bearer ${token}`,
        "x-app-platform": "web",
        "x-app-version": "v1.0.1",
        "x-device-id": deviceId || "",
      },
      handleSuccess: handleLogoutResponse,
      handleError: handleLogoutError,
    });
  };

  const LogoutAllDevice = () => {
    makeApiRequest({
      url: `https://api-prod.daalchini.co.in/auth/user/logout/all`,
      method: "DELETE",
      headers: {
        Authorization: `Bearer ${token}`,
        "x-app-platform": "web",
        "x-app-version": "v1.0.1",
        "x-device-id": deviceId || "",
      },
      handleSuccess: handleLogoutResponse,
      handleError: handleLogoutError,
    });
  };

  // -------------------- Navigation --------------------
  const goToPaymentsOption = () => {
    localStorage.setItem("paytmOptionFrom", window.location.pathname);
    navigate(`/paymentOption?route=profile`);
  };

  const goToAddTag = () => navigate("/taglist");

  const closePop = () => {
    setGoogle_Pop_flag(false);
    navigate("/");
  };

  const closeOTpPop = () => {
    setGoogle_Pop_flag(true);
    setGoogle_OTP_Pop_flag(false);
  };

  // -------------------- Google OTP & Mobile --------------------
  const handle_Number = (e) => setNumber(e.target.value);

  const googleAddnumber = () => {
    if (number.length !== 10) {
      setNumberError(true);
      setNumberErrorMsg("Enter a valid mobile number");
      return;
    }

    setNumberError(false);
    makeApiRequest({
      url: `https://api-prod.daalchini.co.in/auth/user/authenticate`,
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "x-app-platform": "web",
        "x-app-version": "v1.0.1",
        "x-device-id": deviceId || "",
      },
      data: {
        request: {
          mobileNo: number,
          googleId: localStorage.getItem("gmail"),
        },
      },
      handleSuccess: (res) => {
        setGoogle_requestId(res.data.response.requestId);
        setGoogle_Pop_flag(false);
        setGoogle_OTP_Pop_flag(true);
      },
      handleError: (err) => {
        setNumberError(true);
        setNumberErrorMsg(err.response.data.statusMessage);
        toast.error(err.response.data.statusMessage, {
          position: "top-right",
          autoClose: 1000,
        });
      },
    });
  };

  const googleOtpSubmit = () => {
    if (otp.length !== 4) {
      setOtpError(true);
      return;
    }

    setOtpError(false);

    makeApiRequest({
      url: `https://api-prod.daalchini.co.in/auth/user/login`,
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "x-app-platform": "web",
        "x-app-version": "v1.0.1",
        "x-device-id": deviceId || "",
      },
      data: {
        request: {
          deviceId: deviceId,
          fcmUserToken: null,
          mobileNo: number,
          otp: otp,
          requestId: google_requestId,
          sourcePlatform: "web",
        },
      },
      handleSuccess: (res) => {
        const response = res?.data?.response;
        if (response) {
          setGoogle_success_flag(true);
          setGoogle_OTP_Pop_flag(false);
          localStorage.setItem("UserJWTAuth", response.jwt);
          localStorage.setItem("referCode", response.referCode);
          localStorage.setItem("isUserLogged", response.isUserLogged);
          localStorage.setItem("isGuest", response.isGuest);
          localStorage.setItem("isTokenExpired", response.isTokenExpired);
        } else if (res?.data?.status === "FAILURE") {
          setOtpError(true);
          setOtpErrorMsg(res?.data?.statusMessage);
        }
      },
      handleError: () => setOtpError(true),
    });
  };




    useEffect(()=>{
fetchPaymentOption()

    },[])
const fetchPaymentOption = (preCardVmID) => {
  const machineId = localStorage.getItem("machineId");
 // if (!machineId) return; // Guard condition

  const UserJWTAuth = localStorage.getItem("UserJWTAuth");
  const deviceId = localStorage.getItem("uuid");

  const url =
    "/myCart" === localStorage.getItem("paytmOptionFrom") && preCardVmID
      ? `https://api-prod.daalchini.co.in/consumerbe/api/v2/payment/option?machineId=${preCardVmID}&balancePgArr=PAYTM%7CWALLET_LOYALTY%7CWALLET`
      : `https://api-prod.daalchini.co.in/consumerbe/api/v2/payment/option?&balancePgArr=PAYTM%7CWALLET_LOYALTY%7CWALLET`;

  makeApiRequest({
    url,
    method: "GET",
    headers: {
      Authorization: `Bearer ${UserJWTAuth}`,
      "x-app-platform": "web",
      "x-app-version": "v1.0.1",
      "x-device-id": deviceId,
    },
    request: {
      machineId: machineId,
    },
    handleSuccess: (res) => {
        //console.log("payment option list",res)
        setPaymentOptionsList(res.data.data)
     
    },
    handleError: (err) => {
    

      const uuid = deviceId;
       if(localStorage.getItem('Guest_clientId')){
    navigate('/login?route=profile')
  }
  else{
      if (machineId && uuid) {
        navigate(`/login?machineId=${machineId}&vale=${uuid}`);
      }
    }
    },
  });
};
useEffect(()=>{
 
  //console.log("UserJWTAuth BusinessPaymentContainer",UserJWTAuth)
 
  
 },[])
 
  // -------------------- Render --------------------
  return (
    <ProfileScreen
    paymentOptionsList={paymentOptionsList}
      setProfileData={setProfileData}
      profileData={profileData}
      goToPaymentsOption={goToPaymentsOption}
      goToAddTag={goToAddTag}
      LogoutAllDevice={LogoutAllDevice}
      LogoutCurrentDevice={LogoutCurrentDevice}
      google_Pop_flag={google_Pop_flag}
      closePop={closePop}
      handle_Number={handle_Number}
      googleAddnumber={googleAddnumber}
      number={number}
      setNumber={setNumber}
      google_OTP_Pop_flag={google_OTP_Pop_flag}
      closeOTpPop={closeOTpPop}
      numberError={numberError}
      otpError={otpError}
      googleOtpSubmit={googleOtpSubmit}
      setOtp={setOtp}
      otp={otp}
      google_success_flag={google_success_flag}
      setGoogle_success_flag={setGoogle_success_flag}
      otpErrorMsg={otpErrorMsg}
      numberErrorMsg={numberErrorMsg}

      fetchUserDetails={fetchUserDetails}
    />
  );
};

export default UserprofileContainer;
